module.exports = __webpack_public_path__ + "static/media/offering-card-two.69abd8f0.svg";